import { render, staticRenderFns } from "./contract.item.record.list.vue?vue&type=template&id=b4d88762&scoped=true&"
import script from "./contract.item.record.list.vue?vue&type=script&lang=js&"
export * from "./contract.item.record.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d88762",
  null
  
)

export default component.exports